/* eslint-disable no-restricted-syntax */
/* eslint-disable require-jsdoc */
'use strict';

const { queryFirst, queryAll, addClass, removeClass, hasClass } = require('../../domUtil');
const { HIDDEN_CLASS, SHOW_CLASS, EMAIL_REGEX, PHONE_NUMBER_REGEX, D_FLEX, ACTIVE_CLASS, INACTIVE_CLASS, breakpoints } = require('../../constants');
const TULIP_OPTIONS = {
    integrationId: 'INTEGRATION_ID',
    useGeolocation: true,
    browserStorage: 'sessionStorage',
    imageUploadEnabled: true,
    fixedIntroPane: false,
    displayStyle: 'button',
    saveOpenState: true,
    buttonWidth: '50px',
    buttonHeight: '50px',
    businessName: 'Chat with a Stylist',
    businessIconUrl: 'https://scene7.lillypulitzer.com/is/content/sugartown/tulip_lilly_favicon_v2',
    cssOverwritePath: 'cssOverwritePath',
    customColors: { brandColor: '0f0c0c', conversationColor: 'EEE', actionColor: 'FF0000' },
    awayMode: {
        pooledConversations: { enabled: true, unresponsiveTime: 300, showChannelSwitchPrompt: true },
        assignedConversations: { enabled: true, unresponsiveTime: 600, showChannelSwitchPrompt: true }
    },
    messageDelivered: {},
    afterLoadCallback: function () {
        const CHAT_HEADER = 'Chat with a Stylist';
        const SMS_HEADER = 'CONNECT SMS';
        const PROVIDE_PHONE_NUMBER = 'Please provide your phone number to continue with a stylist.';
        const SYNC_MSG = 'Sync your conversation';
        const PHONE_NUM_ERROR = 'Please enter a valid phone number';
        const ENTER_VALID_EMAIL = 'Please enter a valid email address';
        const REQUIRED_FIELD = 'This is a required field';
        const PENDING_SMS_MSG = 'Thank you! You should expect a message from us momentarily.';
        const LINKED_SMS_MSG = 'Check your messages to confirm your phone number and a stylist will connect with you shortly.';
        const SEPARATOR_LINE = 'separator-line';
        const CONTINUE_BTN_TEXT = 'Continue';
        const INPUT_FOCUSED = 'input-focused';
        const LOCATION_REQUEST = 'Send location';
        const iframe = queryFirst('#web-messenger-container');
        if (iframe) {
            const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
            const footerForm = queryFirst('#footer form', iframeDoc);

            initializeEnterButton(footerForm, iframeDoc);

            const observer = new MutationObserver(function (mutationsList) {
                for (let mutation of mutationsList) {
                    if (mutation.type === 'childList') {
                        mutation.addedNodes.forEach(function (addedNode) {
                            if (addedNode.nodeType === Node.ELEMENT_NODE) {
                                if (addedNode.matches('.settings.settings-enter.settings-enter-active')) {
                                    createNewButton(addedNode, iframeDoc);
                                }
                                if (addedNode.matches('.country-list')) {
                                    handleCountryListDisplay(iframeDoc);
                                    toggleSmsLinkingClass(iframeDoc);
                                    disableSmsLinkingButton(iframeDoc);

                                    const sendButton = queryFirst('.sms-linking .btn.btn-primary', iframeDoc);
                                    if (sendButton) sendButton.disabled = true;

                                    const wrapper = queryFirst('#mount.medium-screen #wrapper', iframeDoc);

                                    if (wrapper) moveSmsLinkingToContainer(wrapper, iframeDoc);
                                }
                                if (addedNode.matches('.unread-badge')) {
                                    manageChatIconState(iframeDoc);
                                }
                                if (addedNode.matches('.row.left-row')) {
                                    hideFillOutMessageAfterSubmit(iframeDoc);
                                    displayUnderMsgTimeStamp(iframeDoc);

                                    const { firstElementChild } = addedNode;
                                    if (firstElementChild && firstElementChild.innerText.trim() === 'Be notified when you get a reply >') {
                                        expandClickableNotificationArea(firstElementChild);
                                    }
                                }
                                if (addedNode.matches('.row.right-row')) {
                                    displayUnderMsgTimeStamp(iframeDoc);
                                }
                                if (addedNode.matches('.send.footer-transition.active')) {
                                    addOrRemoveIconArrow(iframeDoc);
                                }
                                if (addedNode.matches('form.upload-enter.upload-enter-active')) {
                                    collapseUploadSection(iframeDoc);
                                }
                                if (addedNode.matches('.warning-message')) {
                                    updateWarningMsgText(iframeDoc);
                                    handleWarningMsgClone(iframeDoc);
                                }
                                if (addedNode.matches('#footer.footer-transition.disabled')) {
                                    initializeEnterButton(footerForm, iframeDoc);
                                    attachListenersToFormInputs(iframeDoc, footerForm);
                                    const inputs = queryAll('.input-group .form-control', iframeDoc);
                                    if (inputs.length !== 0) {
                                        handleInputState(iframeDoc, inputs, footerForm);
                                    }
                                }
                                if (addedNode.children.length > 0) {
                                    if (queryFirst('label.image-upload', addedNode)) {
                                        createArrowLink(iframeDoc);
                                        addOrRemoveIconArrow(iframeDoc);
                                    }
                                }
                                if (addedNode.matches('#footer.footer-transition')) {
                                    const connectHeader = queryFirst('.header-content .header-title', iframeDoc);
                                    const headerWrapper = queryFirst('#header.header-wrapper', iframeDoc);
                                    if (connectHeader) connectHeader.textContent = CHAT_HEADER;
                                    if (headerWrapper) addClass(headerWrapper, D_FLEX);
                                }
                                if (addedNode.matches('.left-row.row-form')) {
                                    attachListenersToFormInputs(iframeDoc, footerForm);
                                    if (addedNode.matches('.conversation-description')) {
                                        const chatHeader = queryFirst('.settings-content .header-title', iframeDoc);
                                        const containerElem = queryFirst('.channel-item-content', iframeDoc);
                                        if (chatHeader) chatHeader.textContent = SMS_HEADER;
                                        addCheckMark(containerElem);
                                    }
                                    if (addedNode.matches('.conversation-description')) {
                                        const chatHeader = queryFirst('.settings-content .header-title', iframeDoc);
                                        const containerElem = queryFirst('.settings.settings-enter-done', iframeDoc);
                                        if (chatHeader) chatHeader.textContent = SMS_HEADER;
                                        addCheckMark(containerElem);
                                        updateButtonStateAndText(iframeDoc);
                                    }
                                }
                                if (addedNode.matches('.conversation-description')) {
                                    const chatHeader = queryFirst('.settings-content .header-title', iframeDoc);
                                    const channelDescription = queryFirst('.channel-description', iframeDoc);
                                    const pendingPhoneNum = queryFirst('span.phone-number', iframeDoc);
                                    const oldHeader = chatHeader?.textContent.trim();
                                    disableSmsLinkingButton(iframeDoc);
                                    smsLinkedState(iframeDoc);
                                    if (chatHeader && channelDescription && oldHeader === SYNC_MSG) {
                                        chatHeader.textContent = SMS_HEADER;
                                        channelDescription.textContent = PROVIDE_PHONE_NUMBER;
                                        updateButtonStateAndText(iframeDoc);
                                    }
                                    if (pendingPhoneNum) {
                                        channelDescription.textContent = PENDING_SMS_MSG;
                                        appendSmsStateText(iframeDoc);
                                        const primaryBtn = queryFirst('.btn-primary.sms-linking', iframeDoc);
                                        if (primaryBtn) primaryBtn.disabled = true;
                                    }
                                    enableSendButtonIfTelValid(iframeDoc);
                                }
                                if (addedNode.matches('span.phone-number')) {
                                    const channelDescription = queryFirst('.channel-description', iframeDoc);
                                    if (channelDescription) {
                                        channelDescription.textContent = PENDING_SMS_MSG;
                                        appendDoneButton(iframeDoc);
                                        appendSmsStateText(iframeDoc);
                                        const primaryBtn = queryFirst('.btn-primary.sms-linking', iframeDoc);
                                        if (primaryBtn) primaryBtn.disabled = true;
                                        enableSendButtonIfTelValid(iframeDoc);
                                    }
                                }
                                if (addedNode.matches('.channel-item-linked')) {
                                    smsLinkedState(iframeDoc);
                                }
                                if (addedNode.matches('.channel-item-connected-as')) {
                                    smsLinkedState(iframeDoc);
                                    queryFirst('.pending-state-text', iframeDoc)?.remove();
                                }
                                if (addedNode.matches('.btn.btn-primary')) {
                                    enableSendButtonIfTelValid(iframeDoc);
                                    const warningMsg = queryFirst('.unlinked-state .warning-message', iframeDoc);
                                    if (warningMsg) {
                                        const clonedWarningMsg = queryFirst('.channel-header .warning-message', iframeDoc);
                                        if (clonedWarningMsg) removeClass(clonedWarningMsg, HIDDEN_CLASS);
                                    }
                                    const primaryBtn = queryFirst('.btn.btn-primary', iframeDoc);
                                    const buttonText = primaryBtn?.textContent.trim();
                                    if (buttonText === 'Send me a text') {
                                        queryFirst('.pending-state-text', iframeDoc)?.remove();
                                        primaryBtn.textContent = CONTINUE_BTN_TEXT;
                                    }
                                }
                                if (addedNode.matches('#settings-handle')) {
                                    const introPane = queryFirst('.intro-pane', iframeDoc);
                                    const conversation = queryFirst('#conversation', iframeDoc);
                                    const expectedText = 'Sync your conversation and continue messaging us through your favorite app.';
                                    const msgWrapper = queryFirst('.msg-wrapper form', iframeDoc);
                                    if (msgWrapper) {
                                        addClass(introPane, HIDDEN_CLASS);
                                        removeClass(conversation, SEPARATOR_LINE);
                                    } else if (introPane && introPane.textContent.includes(expectedText)) {
                                        addClass(conversation, SEPARATOR_LINE);
                                        removeClass(introPane, HIDDEN_CLASS);
                                    }
                                }
                                if (addedNode.matches('div.reply-container')) {
                                    const locationReq = queryFirst('div.reply-container span', iframeDoc);

                                    if (locationReq) {
                                        const textNode = Array.from(locationReq.childNodes).find(
                                            node => node.nodeType === Node.TEXT_NODE && node.textContent.trim() === 'Send Location'
                                        );
                                        if (textNode) {
                                            textNode.textContent = LOCATION_REQUEST;
                                        }
                                    }
                                }
                            }
                        });
                        mutation.removedNodes.forEach(removedNode => {
                            if (removedNode.nodeType === Node.ELEMENT_NODE) {
                                if (removedNode.matches('#footer.footer-transition') || removedNode.matches('.conversation-description')) {
                                    const containerElem = queryFirst('.channel-item-content', iframeDoc);
                                    const connectHeader = queryFirst('.settings-content .header-title', iframeDoc);
                                    if (connectHeader) connectHeader.textContent = SMS_HEADER;
                                    addCheckMark(containerElem);
                                    updateButtonStateAndText(iframeDoc);
                                    smsLinkedState(iframeDoc);
                                }
                                if (removedNode.matches('.btn.btn-primary.inactive')) {
                                    const parentContainer = mutation.target;
                                    updateButtonStateAndText(iframeDoc);
                                }
                                if (removedNode.matches('.send.footer-transition.active')) {
                                    addOrRemoveIconArrow(iframeDoc);
                                    resetTextAreaHeight(iframeDoc);
                                    removeFocus(iframeDoc);
                                }
                                if (removedNode.matches('.country-list')) {
                                    toggleSmsLinkingClass(iframeDoc);
                                    disableSmsLinkingButton(iframeDoc);
                                    const channelContent = queryFirst('#mount.medium-screen .channel-pages-container .channel-content', iframeDoc);
                                    if (channelContent) moveSmsLinkingToContainer(channelContent, iframeDoc);
                                }
                                if (removedNode.matches('.warning-message')) {
                                    updateWarningMsgText(iframeDoc);
                                    removeWarningMsgClone(iframeDoc);
                                    toggleSmsLinkingClass(iframeDoc);
                                }
                                if (removedNode.matches('.row.left-row')) {
                                    smsLinkedState(iframeDoc);
                                }
                                if (removedNode.matches('a')) {
                                    const unlinkedStateElement = queryFirst('.sms-linking.unlinked-state', iframeDoc);
                                    const linkedStateElement = queryFirst('.sms-linking.linked-state', iframeDoc);
                                    if (unlinkedStateElement || linkedStateElement) {
                                        const doneButton = queryFirst('.stylist-chat-sms-linking-done', iframeDoc);
                                        doneButton?.remove();
                                        const channelDescription = queryFirst('.channel-description', iframeDoc);
                                        if (channelDescription) {
                                            channelDescription.textContent = PROVIDE_PHONE_NUMBER;
                                        }
                                        enableSendButtonIfTelValid(iframeDoc);
                                    }
                                }
                            }
                        });
                    }
                }
            });
            observer.observe(queryFirst('#wrapper', iframeDoc), { childList: true, subtree: true });

            listenerForTextArea(iframeDoc);
            displayUnderMsgTimeStamp(iframeDoc);
            hideFillOutMessageAfterSubmit(iframeDoc);
            removeFocus(iframeDoc);

            window.addEventListener('load', sendBreakpointToIframe(iframeDoc));
            window.addEventListener('resize', () => {
                sendBreakpointToIframe(iframeDoc);
            });

            let footerTransitionBtn = queryFirst('.send.footer-transition.active');
            if (!footerTransitionBtn) {
                createArrowLink(iframeDoc);
            }
        }

        /**
        * Create & appends the "START CHAT" button to the footer container inside the iframe.
        * @param {HTMLElement} footerForm - The form which contains the start chat button.
        * @param {Document} iframeDoc - The iFrame document.
        */
        function initializeEnterButton(footerForm, iframeDoc) {
            const footerContainer = queryFirst('.input-container.text-input-container.footer-transition', iframeDoc);

            if (footerContainer) {
                const handleClick = () => {
                    queryAll('.form-field-btn', iframeDoc).forEach(button => button.click());
                    removeClass(footerForm, 'active-start-chat-btn');
                    updateErrorMessages(iframeDoc);
                };

                const enterButton = document.createElement('button');
                enterButton.textContent = 'START CHAT';
                addClass(enterButton, 'start-chat-btn');

                enterButton.addEventListener('click', handleClick);

                footerContainer.appendChild(enterButton);

                footerContainer.addEventListener('click', handleClick);
            }
        }

        /**
        * Updates the warning message text
        * @param {Document} iframeDoc - The iFrame document.
        */
        function updateWarningMsgText(iframeDoc) {
            const warningMsg = queryFirst('.warning-message', iframeDoc);
            const channelHeader = queryFirst('.content-wrapper .channel-header', iframeDoc);

            if (!warningMsg || !channelHeader) return;

            if (warningMsg.textContent.trim().toLowerCase().includes('we were unable to communicate with this number')) {
                warningMsg.textContent = PHONE_NUM_ERROR;
                addClass(channelHeader, 'warning-message-spacing');
            } else {
                removeClass(channelHeader, 'warning-message-spacing');
            }
        }

        /**
        * Function to handle cloning and appending an error element
        * @param {Document} iframeDoc - The iFrame document.
        */
        function handleWarningMsgClone(iframeDoc) {
            const warningMsg = queryFirst('.warning-message', iframeDoc);
            const channelHeader = queryFirst('.content-wrapper .channel-header', iframeDoc);

            const regex = /(cancel|number was requested)/i;

            if (warningMsg && regex.test(warningMsg.textContent.trim())) {
                const match = warningMsg.textContent.trim().toLowerCase().match(regex);
                const keyword = match ? match[1].replace(/\s+/g, '-').toLowerCase() : null;

                const existingClone = queryFirst('.warning-message-clone', iframeDoc);
                if (!existingClone && keyword) {
                    const clonedWarningMsg = warningMsg.cloneNode(true);
                    clonedWarningMsg.classList.add('warning-message-clone', `warning-${keyword}`);
                    channelHeader.insertBefore(clonedWarningMsg, channelHeader.firstChild);
                    warningMsg.style.display = 'none';
                }
            }
        }
        /**
        * Function to handle removing the cloned node when the original is removed
        * @param {Document} iframeDoc - The iFrame document.
        */
        function removeWarningMsgClone(iframeDoc) {
            const clonedWarningMsg = queryFirst('.warning-message-clone', iframeDoc);
            if (clonedWarningMsg) {
                clonedWarningMsg.remove();
            }

            const warningMsg = queryFirst('.warning-message', iframeDoc);
            if (warningMsg) {
                warningMsg.style.display = '';
            }
        }

        /**
        * Add class based on breakpoint
        * @param {Document} iframeDoc - The iFrame document.
        */
        function sendBreakpointToIframe(iframeDoc) {
            const mount = queryFirst('#mount', iframeDoc);
            const parentWidth = window.innerWidth;

            if (parentWidth >= breakpoints.md) {
                addClass(mount, 'medium-screen');
            } else {
                removeClass(mount, 'medium-screen');
            }
        }

        /**
        * add/remove 'opened' class when dropdown is open
        * @param {Document} iframeDoc - The iFrame document.
        * @returns {void}
        */
        function toggleSmsLinkingClass(iframeDoc) {
            const dropdown = queryFirst('.flag-dropdown', iframeDoc);
            const smsLinking = queryFirst('.sms-linking', iframeDoc);
            const channelContent = queryFirst('.channel-content', iframeDoc);

            if (!smsLinking || !channelContent) return false;

            if (hasClass(dropdown, 'open-dropdown')) {
                addClass([smsLinking, channelContent], 'opened');
            } else {
                removeClass([smsLinking, channelContent], 'opened');
            }

            const reactTelInput = queryFirst('.sms-linking .react-tel-input .form-control', iframeDoc);
            if (reactTelInput) {
                reactTelInput.addEventListener('click', (event) => {
                    event.preventDefault();
                    event.stopPropagation();
                });
            }
        }

        /**
        * Function to handle blur events and remove the active class if input is empty
        * @param {HTMLElement} inputElement - The input element being blurred.
        * @param {Document} iframeDoc - The iFrame document.
        */
        function removeLabelOnBlur(inputElement, iframeDoc) {
            const label = queryFirst(`label[for='${inputElement.id}'].control-label`, iframeDoc);
            if (label && !inputElement.value.trim()) {
                removeClass(label, ACTIVE_CLASS);
            }
        }

        /**
        * Event listener for clicks outside the dropdown to show/hide upload container
        * @param {Document} iframeDoc - The iFrame document.
        */
        function collapseUploadSection(iframeDoc) {
            const uploadContainer = queryFirst('.upload-container', iframeDoc);
            const conversation = queryFirst('#conversation', iframeDoc);
            if (conversation && uploadContainer) {
                conversation.addEventListener('click', (event) => {
                    if (!uploadContainer.contains(event.target)) {
                        const imageUpload = queryFirst('.image-upload.toggled', iframeDoc);
                        addClass([uploadContainer], HIDDEN_CLASS);
                        if (imageUpload) imageUpload.click();
                    }
                });
            }
        }

        /**
        * Adds 'active' class to the label
        * @param {string} labelName - The name of the label for the input element.
        * @param {Document} iframeDoc - The iFrame document.
        */
        function addLabel(labelName, iframeDoc) {
            const label = queryFirst(`label[for='${labelName}'].control-label`, iframeDoc);
            if (label) {
                addClass(label, ACTIVE_CLASS);
            }
        }

        /**
        * Function to handle input events and update label
        * @param {HTMLElement} inputElement inputElement
        * @param {Document} iframeDoc - The iFrame document.
        */
        function handleInput(inputElement, iframeDoc) {
            const label = queryFirst(`label[for="${inputElement.id}"].control-label`, iframeDoc);
            if (label) {
                if (!inputElement.value.trim()) {
                    removeClass(label, ACTIVE_CLASS);
                } else {
                    addClass(label, ACTIVE_CLASS);
                }
            }
        }

        /**
        * Function to update error messages
        * @param {Document} iframeDoc - The iFrame document.
        */
        function updateErrorMessages(iframeDoc) {
            const helpBlocks = queryAll('.help-block.help-block--visible', iframeDoc);
            helpBlocks.forEach(helpBlock => {
                const currentMessage = helpBlock.textContent.trim();
                if (currentMessage === 'Email is invalid') {
                    helpBlock.textContent = ENTER_VALID_EMAIL;
                } else if (currentMessage === 'This entry is required') {
                    helpBlock.textContent = REQUIRED_FIELD;
                }
            });
        }

        /**
        * Handles the state of the input fields and updates the UI based on validation.
        * @param {Document} iframeDoc - The iFrame document.
        * @param {HTMLElement[]} inputs - An array of input elements tobe validated and add class.
        * @param {HTMLElement} footerForm - The footer form element.
        * @returns {void}
        */
        function handleInputState(iframeDoc, inputs, footerForm) {
            const email = queryFirst('#email', iframeDoc);
            const enterButton = queryFirst('.start-chat-btn', iframeDoc);
            const textInputContainer = queryFirst('#footer .input-container.text-input-container.footer-transition', iframeDoc);

            if (email && textInputContainer && enterButton) {
                const validEmail = EMAIL_REGEX.test(email.value);

                if (validEmail && inputs.every(input => !!input.value.trim())) {
                    addClass([enterButton, footerForm, textInputContainer], 'active-start-chat-btn');
                } else {
                    removeClass([enterButton, footerForm, textInputContainer], 'active-start-chat-btn');
                }
            }
        }

        /**
         * Function to attache event listeners to input fields to handle input state.
         * @param {Document} iframeDoc - The iFrame document
         * @param {HTMLElement} footerForm - The footer form element.
         */
        function attachListenersToFormInputs(iframeDoc, footerForm) {
            const inputs = queryAll('.input-group .form-control', iframeDoc);
            const { body } = document;

            if (inputs.length !== 0 && footerForm) {
                inputs.forEach(input => {
                    input.addEventListener('input', () => {
                        handleInputState(iframeDoc, inputs, footerForm);
                        handleInput(input, iframeDoc);
                    });

                    // Add focus and blur event listeners
                    input.addEventListener('focus', () => {
                        handleInput(input, iframeDoc);
                        handleInputState(iframeDoc, inputs, footerForm);
                        addClass(body, INPUT_FOCUSED);
                    });

                    input.addEventListener('blur', () => {
                        handleInputState(iframeDoc, inputs, footerForm);
                        if (!input.value.trim()) {
                            removeLabelOnBlur(input, iframeDoc);
                        } else {
                            handleInput(input, iframeDoc);
                        }
                        removeClass(body, INPUT_FOCUSED);
                    });
                });
            }
        }

        /**
         * Function that adds event listener on a textarea input field to reset the height and add arrow icon.
         * @param {Document} iframeDoc - The iFrame document
         */
        function listenerForTextArea(iframeDoc) {
            const { body } = document;
            const textarea = queryFirst('.input-container.footer-transition .message-input', iframeDoc);
            if (textarea) {
                textarea.addEventListener('input', () => {
                    resetTextAreaHeight(iframeDoc);
                    textarea.setAttribute('maxlength', '250');
                    addOrRemoveIconArrow(iframeDoc);
                });
                textarea.addEventListener('focus', () => {
                    addClass(body, INPUT_FOCUSED);
                });
            }
        }

        /**
        * Function to set button active based on tel input
        * @param {Document} iframeDoc - The iFrame document
        * @returns {void}
        */
        function enableSendButtonIfTelValid(iframeDoc) {
            const phoneNum = queryFirst('.react-tel-input .form-control', iframeDoc);
            const sendButton = queryFirst('.sms-linking .btn.btn-primary', iframeDoc);

            if (!phoneNum || !sendButton) return false;

            phoneNum.setAttribute('maxlength', '15');

            phoneNum.addEventListener('input', () => {
                const validPhoneNum = PHONE_NUMBER_REGEX.test(phoneNum.value);

                if (validPhoneNum) {
                    addClass(sendButton, ACTIVE_CLASS);
                    sendButton.disabled = false;
                } else {
                    removeClass(sendButton, ACTIVE_CLASS);
                    sendButton.disabled = true;
                }

                const clonedWarningMsg = queryFirst('.warning-message-clone', iframeDoc);
                if (clonedWarningMsg) {
                    addClass(clonedWarningMsg, HIDDEN_CLASS);
                }
            });
        }

        /**
        * Function that disables the "Send" button in SMS linking
        * @param {Document} iframeDoc - The iFrame document
        * @returns {void}
        */
        function disableSmsLinkingButton(iframeDoc) {
            const sendButton = queryFirst('.sms-linking .btn.btn-primary', iframeDoc);
            if (!sendButton) return false;
            if (hasClass(sendButton, ACTIVE_CLASS)) {
                sendButton.disabled = false;
            } else {
                sendButton.disabled = true;
            }
        }

        /**
         * Function to add/remove the newly appended link
         * @param {Document} iframeDoc - The iFrame document
         * @returns {void}
         */
        function addOrRemoveIconArrow(iframeDoc) {
            const footerTransitionBtn = queryFirst('.send.footer-transition.active', iframeDoc);
            const textarea = queryFirst('.input-container.text-input-container.footer-transition textarea', iframeDoc);
            const addedIcon = queryFirst('#send-arrow-icon', iframeDoc);

            if (!textarea || !addedIcon) return false;
            if (footerTransitionBtn && textarea.value.length !== 0) {
                addedIcon.style.display = 'none';
            } else {
                addedIcon.style.display = 'block';
            }
        }

        /**
         * Function to reset text area height
         * @param {Document} iframeDoc - The iFrame document
         */
        function resetTextAreaHeight(iframeDoc) {
            const textarea = queryFirst('.input-container.text-input-container.footer-transition textarea', iframeDoc);

            requestAnimationFrame(() => {
                textarea.style.height = 'auto';
                textarea.rows = Math.min(textarea.rows, 1);
                textarea.setAttribute('maxlength', '250');
                if (textarea.value.trim()) {
                    textarea.style.height = Math.min(textarea.scrollHeight, 250) + 'px';
                    textarea.rows = Math.min(textarea.rows, 25);
                }
            });
        }

        /**
         * Function to create and append the <a> element
         * @param {Document} iframeDoc - The iFrame document
         *  @returns {link} returns new link
         */
        function createArrowLink(iframeDoc) {
            const footer = queryFirst('#footer', iframeDoc);
            const submittedForm = queryFirst('.msg.msg-form.form-submitted', iframeDoc);
            const conversation = queryFirst('#conversation', iframeDoc);

            if (!submittedForm || !footer) return false;

            if (conversation) {
                addClass(conversation, 'border-bottom');
            }

            const link = document.createElement('a');
            link.id = 'send-arrow-icon';
            footer.appendChild(link);
            return link;
        }

        /**
         * Function to show/hide fill out message and timestamp
         * @param {Document} iframeDoc - The iFrame document
         */
        function hideFillOutMessageAfterSubmit(iframeDoc) {
            const submittedForm = queryFirst('.msg.msg-form.form-submitted', iframeDoc);
            const fillOutMsg = queryFirst('.row.left-row.row-other-user-first.row-other-user-last', iframeDoc);
            const conversationTimestamp = queryFirst('.conversation-timestamp-header', iframeDoc);
            if (submittedForm && fillOutMsg && conversationTimestamp) {
                addClass(fillOutMsg, HIDDEN_CLASS);
                addClass(conversationTimestamp, SHOW_CLASS);
            }
        }

        /**
         * Function that creates a new button
         * @param {Document} iframeDoc - The iFrame document
         * @returns { void }
         */
        function appendSmsStateText(iframeDoc) {
            const pendingState = queryFirst('.sms-linking.pending-state', iframeDoc);
            const changeNumberLink = queryFirst('a', pendingState);
            let pendingText = queryFirst('.pending-state-text', iframeDoc);
            if (!pendingText && pendingState) {
                pendingText = document.createElement('span');
                pendingText.textContent = 'Pending';
                addClass(pendingText, 'pending-state-text');
                pendingState.appendChild(pendingText);
            }

            if (changeNumberLink) {
                changeNumberLink.innerText = 'Change my number';
            }

            const phoneNumberSpan = queryFirst('.phone-number', iframeDoc);
            if (phoneNumberSpan) {
                let phoneNumberText = phoneNumberSpan.textContent;
                phoneNumberSpan.textContent = phoneNumberText.replace(/ - Pending$/, '');
            }
        }

        /**
         * Function that appends a new button
         * @param {Document} iframeDoc - The iFrame document
         * @returns { void }
         */
        function appendDoneButton(iframeDoc) {
            const contentWrapper = queryFirst('.channel-pages-container .content-wrapper', iframeDoc);
            let doneButton = queryFirst('.stylist-chat-sms-linking-done', iframeDoc);
            if (!contentWrapper || doneButton) return false;
            doneButton = document.createElement('button');
            doneButton.textContent = CONTINUE_BTN_TEXT;
            addClass(doneButton, 'stylist-chat-sms-linking-done');
            contentWrapper.appendChild(doneButton);
            doneButton.addEventListener('click', () => {
            });
        }

        /**
         * create a new button
         * @param { addedNode } addedNode added element
         * @param {Document} iframeDoc - The iFrame document
         */
        function createNewButton(addedNode, iframeDoc) {
            const newButton = document.createElement('button');
            const linkedSms = queryFirst('.linked', iframeDoc);
            const linkedChannelHeader = queryFirst('.channel-item-linked .channel-item-header', iframeDoc);
            newButton.textContent = CONTINUE_BTN_TEXT;
            addClass(newButton, 'stylist-chat-sms-continue-btn');
            addedNode.appendChild(newButton);
            newButton.addEventListener('click', () => {
                if (linkedSms && linkedChannelHeader) {
                    linkedChannelHeader.click();
                } else {
                    queryAll('.channel-item-header', iframeDoc).forEach(button => button.click());
                }
            });
        }

        /**
         * Function that show/hide elements display in the CountryList element and update styling
         * @param {Document} iframeDoc - The iFrame document
         */
        function handleCountryListDisplay(iframeDoc) {
            const countryListDropDown = queryFirst('.flag-dropdown', iframeDoc);
            const channelDescription = queryFirst('.channel-description', iframeDoc);
            const formInput = queryFirst('.react-tel-input .form-control', iframeDoc);
            const continueSmsBtn = queryFirst('.channel .btn.btn-primary', iframeDoc);
            const contentWrapper = queryFirst('.channel-pages-container .content-wrapper', iframeDoc);
            const selectedFlag = queryFirst('.channel .selected-flag', iframeDoc);
            const channelContainer = queryFirst('.channel-pages-container .channel.channel-visible', iframeDoc);
            const headerWrapper = queryFirst('.header-wrapper', iframeDoc);
            const countryList = queryFirst('.country-list .country.highlight', iframeDoc);
            const channelContent = queryFirst('.channel-pages-container .content-wrapper .channel-content', iframeDoc);

            function setDisplayNone(elements) {
                elements.forEach(el => {
                    el.style.display = 'none';
                });
            }

            function setDisplayBlock(elements) {
                elements.forEach(el => {
                    el.style.display = 'block';
                });
            }

            setDisplayNone([channelDescription, formInput, continueSmsBtn, selectedFlag, headerWrapper]);
            contentWrapper.style.setProperty('padding-top', '20px', 'important');
            channelContainer.style.setProperty('padding-top', '2px', 'important');

            if (countryListDropDown) {
                countryListDropDown.addEventListener('click', () => {
                    if (hasClass(countryListDropDown, 'open-dropdown')) {
                        contentWrapper.style.setProperty('padding-top', '130px', 'important');
                        setDisplayBlock([channelDescription, formInput, continueSmsBtn]);
                        channelContainer.style.setProperty('padding-top', '64px', 'important');
                        selectedFlag.style.display = 'flex';
                        headerWrapper.style.display = 'flex';
                    } else {
                        contentWrapper.style.setProperty('padding-top', '20px', 'important');
                        setDisplayNone([channelDescription, formInput, continueSmsBtn, selectedFlag]);
                        channelContainer.style.setProperty('padding-top', '2px', 'important');
                        setDisplayNone([headerWrapper]);
                    }
                    toggleSmsLinkingClass(iframe);
                });
            }

            if (countryList) {
                addCheckMark(countryList);
                addClass(channelContent, 'add-bottom-spacing');
            }

            queryFirst('.country-list', iframeDoc).addEventListener('click', () => {
                setDisplayBlock([channelDescription, formInput, continueSmsBtn]);
                contentWrapper.style.setProperty('padding-top', '130px', 'important');
                channelContainer.style.setProperty('padding-top', '64px', 'important');
                selectedFlag.style.display = 'flex';
                headerWrapper.style.display = 'flex';
                removeClass(channelContent, 'add-bottom-spacing');
            });
        }

        /**
         * Function to add check mark
         * @param { parentElement } parentElement parent element
         */
        function addCheckMark(parentElement) {
            let checkMark = queryFirst('.checkmark', parentElement);
            if (!checkMark && parentElement) {
                checkMark = document.createElement('span');
                addClass(checkMark, 'checkmark');
                parentElement.appendChild(checkMark);
            }
        }

        /**
         * Function to expand clickable area
         * @param {Document} iframeDoc - The iFrame document
         * @returns {void}
         */
        function expandClickableNotificationArea(iframeDoc) {
            const connectNotificationIcon = queryFirst('.connect-notification-icon', iframeDoc);
            const connectNotificationText = queryFirst('.connect-notification', iframeDoc);

            if (!connectNotificationIcon || !connectNotificationText) return false;

            connectNotificationText.addEventListener('click', () => {
                connectNotificationIcon.click();
            });

            connectNotificationText.style.cursor = 'pointer';
        }

        /**
         *  Function to update button state
         *  @param {Document} iframeDoc - The iFrame document
         */
        function updateButtonStateAndText(iframeDoc) {
            const continueBtn = queryFirst('.btn.btn-primary', iframeDoc);
            const emptyInput = queryFirst('.form-control.invalid-number.empty', iframeDoc);
            if (continueBtn && emptyInput) {
                addClass(continueBtn, INACTIVE_CLASS);
            } else if (continueBtn) {
                addClass(continueBtn, 'active-start-chat-btn');
            }
        }

        /**
        * Moves the '.sms-linking.unlinked-state' element
        * into a '#wrapper' element or return it back when '.country-list' is removed
        *
        * @param {HTMLElement} parentElm - element where the '.sms-linking' element will be moved.
        * @param {Document} iframeDoc - The iFrame document
        */
        function moveSmsLinkingToContainer(parentElm, iframeDoc) {
            const mediumScreenMount = queryFirst('#mount.medium-screen', iframeDoc);
            const countryListContainer = queryFirst('#mount.medium-screen .sms-linking.unlinked-state', mediumScreenMount);

            if (countryListContainer && parentElm) {
                parentElm.appendChild(countryListContainer);
            }
        }

        /**
         * Function to update chat notification icon and add event listener
         * @param {Document} iframeDoc - The iFrame document
         */
        function manageChatIconState(iframeDoc) {
            const messengerButtonIcon = queryFirst('.messenger-button-icon', iframeDoc);
            const unreadBadge = queryAll('.unread-badge', iframeDoc);
            const newMessage = 'notify-new-msg';

            // Update the chat notification icon
            removeClass(messengerButtonIcon, newMessage);
            if (messengerButtonIcon && unreadBadge.length !== 0) {
                addClass(messengerButtonIcon, newMessage);
                addClass(unreadBadge, HIDDEN_CLASS);
            } else {
                removeClass(messengerButtonIcon, newMessage);
            }

            // Add event listener to chat widget icon
            if (messengerButtonIcon) {
                messengerButtonIcon.addEventListener('click', () => {
                    removeClass(messengerButtonIcon, newMessage);
                });
            }
        }

        /**
         * Function to display a time stamp
         * @param {Document} iframeDoc - The iFrame document
         * @returns { void }
         */
        function displayUnderMsgTimeStamp(iframeDoc) {
            const submittedForm = queryFirst('.msg.msg-form.form-submitted', iframeDoc);
            if (!submittedForm) return false;
            const msgDataTips = queryAll('.msg-wrapper .msg', iframeDoc);
            if (msgDataTips.length === 0) return false;
            msgDataTips.forEach(msgDataTip => {
                let timeMessage = queryFirst('.time-stamp-elm', msgDataTip);
                const msgDataTipValue = msgDataTip.getAttribute('data-tip');
                if (msgDataTipValue && !timeMessage) {
                    timeMessage = document.createElement('div');
                    timeMessage.classList.add('time-stamp-elm');
                    timeMessage.innerText = msgDataTipValue;
                    msgDataTip.appendChild(timeMessage);
                }
            });
            addLabel('email', iframeDoc);
            addLabel('name', iframeDoc);
        }

        /**
        * Removes focus from the textarea after message is submitted.
        * @param {Document} iframeDoc - The iFrame document
        */
        function removeFocus(iframeDoc) {
            const messageInput = queryFirst('.input-container.text-input-container.footer-transition', iframeDoc);
            const textarea = queryFirst('.input.message-input.footer-transition', iframeDoc);

            if (messageInput && textarea) {
                setTimeout(() => {
                    textarea.blur();
                    removeClass(messageInput, 'focused');
                }, 500);
            }
        }

        function smsLinkedState(iframeDoc) {
            const smsLinked = queryFirst('.channel-item-linked', iframeDoc);
            const settingsDescription = queryFirst('.settings-description', iframeDoc);
            const connectedNumber = queryFirst('.channel-item-connected-as', iframeDoc);
            const linkedChannelHeader = queryFirst('.channel-item-header', smsLinked);
            const smsSent = queryFirst('.sms-msg-sent-text', iframeDoc);

            if (!smsLinked || !settingsDescription) return false;
            settingsDescription.textContent = LINKED_SMS_MSG;

            if (connectedNumber) {
                connectedNumber.textContent = connectedNumber.textContent.replace('Connected as ', '').trim();
            }
            if (linkedChannelHeader && !smsSent) {
                const sentText = document.createElement('span');
                sentText.textContent = 'Sent!';
                addClass(sentText, 'sms-msg-sent-text');
                linkedChannelHeader.appendChild(sentText);
            }
        }
    },

    customText: {
        'en-US': {
            prechatCaptureConfirmationText: 'We are connecting you to an associate. If you would like to end this conversation at any point, type 0.',
            awayModeMessageAssigned:
                'Hi {customerName}! It appears you are currently unable to chat with us.Please reach out to Customer Care or leave us a message with your phone number. A Boutique Advisor will get back to you as soon as possible.',
            awayModeMessagePooled: 'Hi {customerName}! It appears you are currently unable to chat with us.Please reach out to or leave us a message with your phone number. A Boutique Advisor will get back to you as soon as possible.',
            connectNotificationSingleText: 'Be notified when you get a reply  >',
            messageDelivered: '',
            smsChannelDescription: 'Please fill out the form to get connected with an associate.',
            messageTimestampFormat: 'hh:mm:ss A'
        }
    },
    prechatCapture: {
        enabled: true,
        fields: [
            { type: 'email', name: 'email', label: 'prechatCaptureEmailLabel', placeholder: 'Email' },
            { type: 'text', name: 'name', label: 'prechatCaptureNameLabel', placeholder: 'Name' }
        ]
    }
};

const APPOINTMENT_OPTIONS = {
    app_key: 'APP_KEY',
    defaultUI: true,
    embed: false,
    includePrivateAppointments: true,
    selectorOptions: {
        service_project: {
            title: 'Select an Appointment Type',
            description: 'Which appointment type would you like?',
            card_image: '{{[project]image_url}}',
            card_title: '{{[project]name}}',
            card_body: '{{[project]description}}',
            card_footer: '<i class="far fa-clock"></i> {{[project]availability.length}}',
            filters: {
                't_disabled': 0,
                't_private': 0
            }
        },
        store_project: {
            title: 'Select a Store',
            description: 'Choose a store from the following that you will be visiting for your appointment.',
            card_title: '[meta]t_store_name',
            card_body: `{{[meta]t_store_address}}, {{[meta]t_store_city}}`,
            card_footer: '[meta]t_store_phone',
            search_bar: {
                enabled: true,
                placeholder: 'Search for a City'
            },
            strategy: 'store_project'
        }
    }
};

let messengerContainer = null;
/**
 * initialize Tulip Chat
 * @param {string} targetID - targetID for proper tulip chat initialization
 */
function initializeTulip(targetID) {
    const { tuliplivechat } = window;

    if (!tuliplivechat) return;

    tuliplivechat.init(TULIP_OPTIONS).then(() => {
        messengerContainer = queryFirst('#web-messenger-container');
        if (!tuliplivechat.isConversationActive()) {
            tuliplivechat.hideChatBubble();
            if (messengerContainer && targetID !== 'stylist-chat-div') {
                if (targetID === 'appointment-chat-btn' || targetID === 'appointment-chat') {
                    const tulipAppointmentWidget = queryFirst('#timekit-project-selector-container');
                    if (tulipAppointmentWidget && messengerContainer) {
                        messengerContainer.style.display = 'none';
                        queryFirst('#floating-button').style.display = 'block';
                        tulipAppointmentWidget.style.display = 'block';
                        addClass(tulipAppointmentWidget, 'open');
                    }
                } else {
                    messengerContainer.style.display = 'block';
                    tuliplivechat.openChatWindow(true);
                }
            }
        }
    });
}

/**
 * Tulip chat configuration function
 * @param {string} integrationID - Tulip integration ID preference value
 * @param {string} cssOverritePath - a path to css Overrite file
 */
function initTulipChat(integrationID, cssOverritePath) {
    // Update integrationId wiht corect value from site preference
    TULIP_OPTIONS.integrationId = integrationID;
    TULIP_OPTIONS.cssOverwritePath = cssOverritePath;
    const { tuliplivechat } = window;
    const stylistChatBtn = queryFirst('#stylist-chat-btn');
    const pdpStylistChat = queryFirst('#stylist-chat');
    const appointmentChat = queryFirst('#appointment-chat-btn');
    const { body, documentElement: html } = document;

    if (!tuliplivechat) return;

    if (stylistChatBtn || appointmentChat || pdpStylistChat) {
        if (!tuliplivechat.isConversationActive()) {
            document.addEventListener('click', (e) => {
                const targetEventId = e.target.id;
                if (targetEventId === 'stylist-chat-btn'
                    || targetEventId === 'appointment-chat-btn'
                    || targetEventId === 'appointment-chat'
                    || targetEventId === 'stylist-chat'
                    || targetEventId === 'stylist-chat-div') {
                    initializeTulip(targetEventId);
                }
            }, { once: true });
        } else {
            initializeTulip(null);
        }
    }

    initEvents();

    tuliplivechat.on('widget:opened', () => {
        if (messengerContainer) {
            removeClass(messengerContainer, HIDDEN_CLASS);
            addClass(messengerContainer, 'web-messenger-new-size');
            addClass(body, 'stylist-chat-overlay-bg');
            addClass(html, 'chat-widget-active');
        }
    });

    tuliplivechat.on('widget:closed', () => {
        const isChatActive = tuliplivechat.isConversationActive();
        tuliplivechat.showChatBubble(isChatActive);
        if (!isChatActive && messengerContainer) {
            addClass(messengerContainer, HIDDEN_CLASS);
        }
        removeClass(body, 'stylist-chat-overlay-bg');
        removeClass(html, 'chat-widget-active');
    });
}
/**
 * Function to initialize events
 */
function initEvents() {
    const stylistChatText = queryFirst('#stylist-chat-text');
    if (stylistChatText) {
        stylistChatText.addEventListener('click', () => {
            window.tuliplivechat.openChatWindow();
        });
    }
}

/**
 * Tulip chat configuration function
 * @param {string} key - Tulip app_key ID preference value
 * @param {string} baseURL - Tulip api_base_url preference value
 */
function initAppointmentConfig(key, baseURL) {
    // Update integrationId wiht corect value from site preference
    APPOINTMENT_OPTIONS.app_key = key;
    if (baseURL && baseURL !== 'null') {
        APPOINTMENT_OPTIONS.api_base_url = baseURL;
    }
    if (window.timekit_project_selector) {
        window.timekit_project_selector.init(APPOINTMENT_OPTIONS).then(() => {
            addClass(queryFirst('#timekit-project-selector-container'), 'open');
            queryFirst('#timekit-header-right').onclick = function () {
                removeClass(queryFirst('#stylist-chat'), 'disable-click');
                if (queryFirst('#stylist-chat-text') !== null) {
                    removeClass(queryFirst('#stylist-chat-text'), 'disable-click');
                }
                removeClass(queryFirst('#timekit-project-selector-container'), 'open');
                queryFirst('#floating-button').style.display = 'none';
            }
        }).catch((error) => {
        });
    }
}

module.exports = {
    initTulipChat: initTulipChat,
    initAppointmentConfig: initAppointmentConfig
};
